var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.linesandangles_een{fill:#111918;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linesandangles_een",
    d: "M20,7l-8-2L3,7v20l9-2l8,2l9-2V5L20,7z M27,23.396l-6.973,1.55l-8-2L5,24.507V18h1v-2H5V8.604 l6.973-1.549l8,2L27,7.493V23.396z M20.707,14.293L22,15.586l1.293-1.293l1.414,1.414L23.414,17l1.293,1.293l-1.414,1.414L22,18.414 l-1.293,1.293l-1.414-1.414L20.586,17l-1.293-1.293L20.707,14.293z M16,16h2v2h-2V16z M12,16h2v2h-2V16z M8,16h2v2H8V16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.3bf96172f234a07d8c9fe8dd3f0ece52.svg";
export { ForwardRef as ReactComponent };